// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const deviseRouter =
  {
    path:roterPre+ `/devise`,
    name: 'devise',
    meta: {
      icon: '',
      title: '店铺装修'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'diy/index',
        name: 'NotificDiyation',
        meta: {
          title: '店铺装修',
          noCache: true,
          activeMenu: `/merchant/devise/diy/list`
        },
        component: () => import('@/views/devise/index.vue')
      },
      {
        path: 'diy/product_category',
        name: 'ProductCategory',
        meta: {
          title: '商品分类',
          noCache: true,
          activeMenu: `/merchant/devise/diy/product_category`
        },
        component: () => import('@/views/devise/goodClass.vue')
      },
      {
        path: 'diy/list',
        name: 'DecorationDiyation',
        meta: {
          title: '装修列表',
          noCache: true,
          activeMenu: `/merchant/devise/diy/list`
        },
        component: () => import('@/views/devise/list.vue')
      }
    ]
  }

export default deviseRouter as RouteRecordRaw